import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const CircleCrossIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M14.1663 8.00032C14.1663 4.59467 11.4059 1.8335 8.00032 1.83333C4.59456 1.83333 1.83333 4.59456 1.83333 8.00032C1.8335 11.4059 4.59467 14.1663 8.00032 14.1663C11.4058 14.1662 14.1662 11.4058 14.1663 8.00032ZM15.1663 8.00032C15.1662 11.9581 11.9581 15.1662 8.00032 15.1663C4.04239 15.1663 0.833504 11.9582 0.833328 8.00032C0.833328 4.04228 4.04228 0.833328 8.00032 0.833328C11.9582 0.833504 15.1663 4.04239 15.1663 8.00032Z"
      fill="currentColor"
    />
    <path
      d="M9.64648 5.64648C9.84174 5.45121 10.1582 5.45121 10.3535 5.64648C10.5488 5.84174 10.5488 6.15825 10.3535 6.35351L6.35351 10.3535C6.15825 10.5488 5.84174 10.5488 5.64648 10.3535C5.45121 10.1582 5.45121 9.84174 5.64648 9.64648L9.64648 5.64648Z"
      fill="currentColor"
    />
    <path
      d="M5.64648 5.64648C5.84174 5.45121 6.15825 5.45121 6.35351 5.64648L10.3535 9.64648C10.5488 9.84174 10.5488 10.1582 10.3535 10.3535C10.1582 10.5488 9.84174 10.5488 9.64648 10.3535L5.64648 6.35351C5.45121 6.15825 5.45121 5.84174 5.64648 5.64648Z"
      fill="currentColor"
    />
  </svg>
);
